import React, { Component } from 'react';
import moment from 'moment';
import { Card } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get, reduce, filter } from 'lodash';
import styled from 'styled-components';
import { Project } from '../common/constant';
import { formatDate } from '../common/datetime';
import Image from '../common/image';
import { ProgressLabel } from '../../uiStandard/event/label';
import { Tag } from '../../uiStandard/event/tag';
import { EVENT_TYPE } from '../cms/constant';


class EventTile extends Component {
  eventStatus = () => {
    const { start, end } = this.props.event;
    const { translate } = this.props;
    if (moment().isBefore(moment(start))) {
      return null;
    }
    if (moment().isAfter(moment(end))) {
      return <StyledProgressLabel isInProgress={false}>{translate('ended')}</StyledProgressLabel>;
    }
    return (
      <StyledProgressLabel isInProgress={false}>{translate('In Progress')}</StyledProgressLabel>
    );
  };

  eventEnd = () => {
    const { end } = this.props.event;
    const { activeLanguage, event } = this.props;
    const { translate } = this.props;
    const startDate = formatDate(event.start, activeLanguage, event.timezone);
    const endDate = formatDate(event.end, activeLanguage, event.timezone);

    if (moment().isAfter(moment(end))) {
      return <span className='status'>{`${startDate} - ${endDate}`}</span>;
    }
    return (
      <span className='status'>{translate('eventInfo.startsOn')} {startDate}</span>
    );
  }

  ticketPrice = () => {
    const { event, translate } = this.props;
    const { type, eventTickets } = event;
    const filteredTickets = filter(eventTickets, t => (
      t.status === 'OPEN'
    ));
    switch (type) {
      case EVENT_TYPE.TICKET: {
        const { minPrice: min, maxPrice: max } = reduce(
          filteredTickets,
          ({ minPrice, maxPrice }, { price }) => ({
            minPrice: minPrice && minPrice < price ? minPrice : price,
            maxPrice: maxPrice && maxPrice > price ? maxPrice : price
          }),
          { minPrice: null, maxPrice: null }
        );

        if (min === null && max === null) {
          return <Tag iconName='ticket' label={translate('text.noTicketAvaliable')} card />;
        } else if (min === max) {
          return <Tag iconName='ticket' label={`Ticket $${min}`} card />;
        } else if (min === 0) {
          return (
            <Tag iconName='ticket' label={`${translate('common.freeEvent')} - CAD ${max}`} />
          );
        }
        return <Tag iconName='ticket' label={`Ticket $${min} - $${max}`} />;
      }
      case EVENT_TYPE.FREE: {
        return <Tag iconName='ticket' label={translate('common.freeEvent')} />;
      }
      default:
        return null;
    }
  }


  render() {
    const { event, translate } = this.props;

    let address = '';
    if (event.location) {
      address = get(JSON.parse(event.location), 'value.address');
    }

    return (
      <CardContainer href={`/event/${event.slug}`} >
        <EventCoverImageContainer className='event-coverImage'>
          <Image
            alt={event.name}
            src={
              event.coverImageUrl
                ? event.coverImageUrl
                : Project.defaultCoverImage
            }
          />
          {this.eventStatus()}
        </EventCoverImageContainer>
        <Card.Content textAlign='left' className='main'>
          <Card.Header>{event.name}</Card.Header>
          <Card.Meta textAlign='left' className='cardContent'>
            <div>
              {
                this.ticketPrice()
              }
              {address &&
                address.formattedAddress ? (
                  <Tag iconName='location' label={address.formattedAddress} card />
                ) : (<Tag iconName='location' label={translate('eventInfo.onlineEvent')}card />)
              }
            </div>
            <InProgressEnd>
              {this.eventEnd()}
            </InProgressEnd>
          </Card.Meta>
        </Card.Content>
      </CardContainer>
    );
  }
}

const CardContainer = styled(Card)`
  &&.ui.card {
    background: #FFFFFF;
    border: 1px solid #E7EDF5;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
    border-radius: 8px;
    width: 100%;
    min-height: 326px;
    height: 100%;

    @media only screen and (max-width: 991px) {
        width:80%;
        margin: auto;
    }
  }

  &&.ui.card:hover {
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  }

  &&.ui.card > .content.main {
    border-top: 1px solid transparent;
  }
  &&.ui.card > .content > .header {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #101828;
    overflow-wrap: break-word;
  }

  .cardContent {
    display: flex;
    flex-direction: column;
    align-content: space-between;
    padding-top: 0.4em;
    span {
      margin: 0;
      padding: 0.4em 0;
      font-size: 16px;
      line-height: 19px;
    }
  }
`;

const EventCoverImageContainer = styled.div`
  position: relative;
  width: calc(100% + 2px);
  top: -1px;
  left: -1px;
  vertical-align:top;

  img {
    border-radius: 8px 8px 0 0;
  }

  && {
    span {
    position: absolute;
    bottom: 0.2rem;
    left: 0.2rem;
  }
}
`;

const StyledProgressLabel = styled(ProgressLabel)`
  font-size: 12px;
  line-height: 18px;
  color: #2F394B;
  background: #F2F4F7;
  border-radius: 16px;
  text-transform: capitalize;
  padding: 0.2em 0.6em;
  font-weight: 500;
  letter-spacing: 0.5px;
`;


const InProgressEnd = styled.div`
  display: flex;
  flex-direction:column;
  justify-content:space-around;
  padding: 0.2em 0 0 0;


  span {
    display:inline-block;
    font-size: 14px;
    font-weight: 500;
    font-family: 'Inter';
    font-style: normal;
    line-height: 19px;
    padding: 1em 0;
    font-weight: 600;
    color: #667085;
  }

  span:first-of-type {
    font-family: 'Inter';
    color: #809FB8;
  }

  span.ongoing{
    background: #C7E8FE;
    border-radius: 6px;
    font-family: 'Lato';
    font-size: 12px;
    line-height: 14px;
    color: #0094FB;
    padding: 0.6em 1em;
    width: 80%;
    text-align:center;
    b {
      font-size: 14px;
    }
  }

  span.start {
    font-family: 'Inter';
    text-align: center;
    color: #06152B;
  }

  span.status {
    color: #667085;
    font-weight: 500;
    line-height: 24px;
  }
`;

export default compose(
  withLocalize,
  connect(({ user }) => ({ user }))
)(EventTile);



// WEBPACK FOOTER //
// ./src/components/events/eventTile.js